var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47965 4C6.00561 4 4 6.00561 4 8.47965V16.2703C4 18.7444 6.00561 20.75 8.47965 20.75H16.2703C18.7444 20.75 20.75 18.7444 20.75 16.2703V8.47965C20.75 6.00561 18.7444 4 16.2703 4H8.47965ZM14.5581 10.1923C14.8509 10.4852 14.8509 10.9601 14.5581 11.253L13.4357 12.3753L14.5581 13.4976C14.8509 13.7905 14.8509 14.2654 14.5581 14.5583C14.2652 14.8512 13.7903 14.8512 13.4974 14.5583L12.3751 13.436L11.2527 14.5583C10.9598 14.8512 10.485 14.8512 10.1921 14.5583C9.89919 14.2654 9.89919 13.7905 10.1921 13.4976L11.3144 12.3753L10.1921 11.253C9.89919 10.9601 9.89919 10.4852 10.1921 10.1923C10.485 9.89943 10.9598 9.89943 11.2527 10.1923L12.3751 11.3146L13.4974 10.1923C13.7903 9.8994 14.2652 9.8994 14.5581 10.1923Z",
    fill: "#FFCACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/CloseSmall.8dd0a2667083c93f0fc305fe812347c6.svg";
export { ForwardRef as ReactComponent };